import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
import InputLabel from '@material-ui/core/InputLabel';
// import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import {format} from 'date-fns';

import './Divisions.css';

const styles = theme => ({
  colorSwitchBase: {
    color: theme.palette.primary.main,
    '&$colorChecked': {
      color: theme.palette.primary.main,
      '& + $colorBar': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  colorBar: {
    backgroundColor: theme.palette.primary.main
  },
  colorChecked: {}
})

class Divisions extends Component {

  constructor(props) {
    super(props);

    this.state = {
      currentlySelectedLeaderboard: process.env.REACT_APP_DIVISION_ROOT,
      currentDivision: 'Male'
    }

    this.switcher = this.switcher.bind(this);
  }

switcher(e) {
    let nowSelected = this.state.currentlySelectedLeaderboard;
    const target = e;
    if(this.state.currentDivision === target) return;

    return this.setState({
      currentlySelectedLeaderboard: target,
      currentDivision: target
    }, () => {
      this.props.switchLeaderboards(target);
    });

  }
  
  componentDidUpdate(prevProps) {
    if(prevProps.divisionId !== this.props.divisionId) {
      this.setState({
        currentlySelectedLeaderboard: this.props.divisionId
      })
    }
  }


  date(dateVal) {
    if(!dateVal) return '-';
    const date = format(new Date(dateVal), 'MMM dd - h b');
    return date;
  }

  render() {
    return (
    <div>
      {/*Division selector, current place indication*/}
      <div className="mt1 padding-hack pa3 relative mb2">
        <div className={'fixed-title w-100 z-3' + (this.props.fixed ? ' ph4 ph5-ns' : '')}>
          <Grid
            container
            justify="space-between"
            alignItems="center">
            <Grid 
              className="tl"
              item
              xs={6}>
              <h2 className="standings mt2 mb1 f6 f6-m f6-l">{'Updated:'} {this.date(this.props.updatedAt)}</h2>
              
              {/*<p className="standings sort-order f7 f6-ns mv1 t-green"
              >Sort: {this.props.eventId < 1 ?
                  'Overall'
                : 'Event ' + (this.props.eventConfig.event_ids ? this.props.eventConfig.event_ids.indexOf(this.props.eventId) + 1 : '')} <i alt="arrow-direction" className={'ml-2 fas ' + (this.props.reverse ? ' fa-sort-amount-down' : 'fa-sort-amount-up')} ></i>
              </p>*/}
            </Grid>
            <Grid 
              item
              lg={2}
              md={3}
              sm={4}
              xs={6}
              className="tr">
              <FormControl 
                className="w-100 mt2">
                <FormGroup 
                  justify="between"
                  row
                  className="items-center justify-end w-100">
                  <div className="mr2">
                    <Button 
                      color="primary" 
                      variant="contained" 
                      className={'pointer button-fix' + (this.state.currentDivision === 'Male'? '' : ' o-50')} 
                      onClick={this.switcher.bind(this, 'Male')}>
                      Male
                    </Button>
                  </div>
                  <div>
                    <Button 
                      color="primary" 
                      variant="contained" 
                      className={'pointer button-fix' + (this.state.currentDivision === 'Female' ? '' : ' o-50')} 
                      onClick={this.switcher.bind(this, 'Female')}>
                      Female
                    </Button>
                  </div>
                </FormGroup>
              </FormControl>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
    )
  }
}

Divisions.propTypes = {
  switchLeaderboards: PropTypes.func.isRequired,
  divisionId: PropTypes.string.isRequired,
  reverse: PropTypes.bool.isRequired,
  eventId: PropTypes.number.isRequired,
  fixed: PropTypes.bool.isRequired,
  activeIdx: PropTypes.number.isRequired,
  howManyToShow: PropTypes.number.isRequired
}

export default withStyles(styles)(Divisions);